import { createSlice } from '@reduxjs/toolkit';
import {
    teslaNodo,
} from '../actions/teslaNodo';


export const TeslaReducerNodo = createSlice({
    name: 'teslaNodo',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(teslaNodo.pending, (state) => { state.loading = true })
            .addCase(teslaNodo.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(teslaNodo.rejected, (state) => { state.loading = false })
    }
})
export default TeslaReducerNodo.reducer;